import { render, staticRenderFns } from "./InformBox.vue?vue&type=template&id=71216d83&scoped=true"
import script from "./InformBox.vue?vue&type=script&lang=js"
export * from "./InformBox.vue?vue&type=script&lang=js"
import style0 from "./InformBox.vue?vue&type=style&index=0&id=71216d83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71216d83",
  null
  
)

export default component.exports